import axios from "axios";
import { useCallback, useContext, useEffect, useState } from "react";
import { NotificationInfo, UserInfo } from "../../../../../context";
import { Button, Collapse, Input, Modal, Spin, Typography } from "antd";
import {
  PlusOutlined,
  EditOutlined,
  SyncOutlined,
  CaretRightOutlined,
  DeleteOutlined,
} from "@ant-design/icons";
import MerchantEmployeeAddExpense from "./MerchantEmployeeAddExpense";
import MerchantEmployeeAddSubExpense from "./MerchantEmployeeAddSubExpense";

const MerchantEmployeeExpenseConfig = ({ expenseConfig, rerun }) => {
  const { userData } = useContext(UserInfo);
  const [search, setSearch] = useState("");
  const [openDrawer, setOpenDrawer] = useState(false);
  const [openSubDrawer, setOpenSubDrawer] = useState(false);
  const [selectedExpense, setSelectedExpense] = useState(null);
  const [selectedExpenseSub, setSelectedExpenseSub] = useState(null);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [deleteDialog, setDeleteDialog] = useState(false);
  const { rerunNotif } = useContext(NotificationInfo);

  //new
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState({});

  const handlePanelChange = async (key) => {
    if (key.length > 0) {
      setSelectedExpense(key[0]);
      setLoading(true);
      try {
        var params = {
          expense_type_id: key[0],
        };
        const response = await axios.get(
          `user/merchant/get/expense-config-sub`,
          {
            params,
          }
        );
        setData(response.data);
      } catch (error) {
        console.error("Error: ", error);
      } finally {
        setLoading(false);
      }
    }
  };

  const enrichedItems = expenseConfig.data.map((item) => ({
    ...item,
    children: loading ? (
      <Spin />
    ) : (
      <div>
        <div style={{ display: "flex", justifyContent: "center" }}>
          <div style={{ flexGrow: 1 }} />
          <Button
            size="small"
            onClick={() => {
              setSelectedExpense(item.key);
              setOpenSubDrawer(true);
            }}
          >
            Add Sub
          </Button>
        </div>
        {data.length > 0 ? (
          data.map((data, index) => (
            <Typography
              key={index}
              style={{
                fontWeight: 500,
                textTransform: "capitalize",
                marginBottom: 5,
              }}
            >
              &bull; {data.description} - {data.id}
              <DeleteOutlined
                style={{ color: "red", marginLeft: 10, cursor: "pointer" }}
                onClick={() => {
                  setDeleteDialog(true);
                  setSelectedExpenseSub(data.id);
                }}
              />
            </Typography>
          ))
        ) : (
          <Typography style={{ textAlign: "center", color: "red" }}>
            No sub expense.
          </Typography>
        )}
      </div>
    ),
  }));

  const searchable = enrichedItems.filter((data) => {
    return data.label.toLowerCase().indexOf(search.toLowerCase()) >= 0;
  });

  const handleOk = () => {
    setConfirmLoading(true);
    setTimeout(() => {
      setDeleteDialog(false);
      setConfirmLoading(false);
      handleDeleteExpenseSub();
    }, 2000);
  };

  const handleDeleteExpenseSub = () => {
    const formdata = new FormData();
    formdata.append(
      "id",
      selectedExpenseSub !== null ? selectedExpenseSub : ""
    );

    axios
      .post("user/merchant/delete/expense-config-sub", formdata)
      .then((response) => {
        const data = response.data;
        if (data === "success") {
          rerunNotif("success", "Delete expense sub successfully.");
          setTimeout(() => {
            handlePanelChange([`${selectedExpense}`]);
          }, 1000);
        }
      })
      .catch((error) => {
        console.log("Error: ", error);
      });
  };

  return (
    <>
      <div style={{ overflowX: "auto" }}>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            marginBottom: 5,
          }}
        >
          <div style={{ flexGrow: 1 }}>
            <Input
              id="search-list"
              placeholder="Search Expense Type"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              style={{
                border: "2px solid #e5e5e5",
                width: window.innerWidth < 576 ? "100%" : 300,
              }}
              size="large"
            />
          </div>
          <Button
            type="primary"
            icon={<PlusOutlined />}
            onClick={() => setOpenDrawer(true)}
            style={{ marginRight: 5 }}
          >
            Add Expense Type
          </Button>
        </div>
        <div>
          <Collapse
            accordion
            items={searchable}
            expandIcon={({ isActive }) => (
              <CaretRightOutlined rotate={isActive ? 90 : 0} />
            )}
            onChange={handlePanelChange}
            style={{ background: "#f5f5f5" }}
            size="small"
          />
        </div>
      </div>

      {openDrawer && (
        <MerchantEmployeeAddExpense
          open={openDrawer}
          close={() => setOpenDrawer(false)}
          setLoading={setLoading}
          rerun={() => rerun()}
        />
      )}

      {openSubDrawer && (
        <MerchantEmployeeAddSubExpense
          open={openSubDrawer}
          close={() => setOpenSubDrawer(false)}
          setLoading={setLoading}
          selectedExpense={selectedExpense}
          rerun={() => handlePanelChange([`${selectedExpense}`])}
        />
      )}

      <Modal
        title="Delete this expense sub?"
        open={deleteDialog}
        onOk={handleOk}
        confirmLoading={confirmLoading}
        onCancel={() => setDeleteDialog(false)}
        centered
      />
    </>
  );
};

export default MerchantEmployeeExpenseConfig;
